export default __webpack_public_path__ + "static/media/g_wdt_c_6.3dc1ee31.mp3";